import styled from 'styled-components';
import { Heading } from 'Typography';

const CardHeader = styled(Heading).attrs({ type: 'h5' })``;

export default CardHeader;
